import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import CheckoutForm from '../Components/Summary/CheckoutForm';
import PolicyPurchased from '../Components/Summary/PolicyPurchased';
import { LabelLarge, Container } from '../elements';
import LoadingSpinner from '../Components/Shared/LoadingSpinnerDots';

const Payment = ({ purchasedPolicies, quoteBindPending }) => {
  return (
    <Container>
      <Overlay active={quoteBindPending}>
        <LoadingSpinner />
        <StyledLabelLarge isDarkTheme>Purchasing Your Policy...</StyledLabelLarge>
      </Overlay>
      {purchasedPolicies?.length > 0 ? <PolicyPurchased /> : <CheckoutForm />}
    </Container>
  );
};

Payment.propTypes = {
  quoteBindPending: PropTypes.bool,
  policyPurchaseErrors: PropTypes.array,
};

const mapStateToProps = (state) => ({
  quoteBindPending: state.quoteBindPending,
  purchasedPolicies: state.purchasedPolicy?.policies || [],
});

const Overlay = styled.div`
  background-color: ${({ theme }) => theme.pageComponents.payment.overlay};
  opacity: 0.75;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 12;
`;

const StyledLabelLarge = styled(LabelLarge)`
  margin-top: 24px;
  font-size: 24px;
`;

export default connect(mapStateToProps)(Payment);
